module.exports = __webpack_public_path__ + "img/lowrisk.6f87fe4c.png";